<div class="search-button">
  <mat-icon>search</mat-icon>
  <div class="ng-value-container">
    <input [formControl]="searchFormControl" class="border-0 w-100 d-block" [placeholder]="placeholder | titlecase"  type="text">
  </div>
</div>
